import React from 'react';

import { usePreloadDynamicIconImages } from '~src/root/hooks/PreloadDynamicIconImages';
import { useSetPreviousUrlHandler } from '~src/root/hooks/SetPreviousUrl';
import { useHistoryNavigationTracker } from '~src/viz/services/VizLoadContextService';

import { useDismissModalsHandler } from './DismissModalsHook';

/**
 * This container is a functional wrapper to allow calling hooks. It must be rendered under a router to get access
 * to react-router contexts
 */
export function RouterHooksContainer(props: React.PropsWithChildren<{}>): JSX.Element {
  usePreloadDynamicIconImages();
  useSetPreviousUrlHandler();
  useDismissModalsHandler();
  useHistoryNavigationTracker();
  return <>{props.children}</>;
}
